import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import WeeksLitterSlider from './../../components/WeeksLitterSlider/WeeksLitterSlider';
import * as actionTypes from './../../store/actions/weeksLitterAction';
import fetchWeeksLitterAction from './../../store/actions/fetch/fetchWeeksLitterAction';
import Loader from './../../components/Loader/Loader'
import * as animalTypeValues from "../AnimalType/AnimalTypeValues";
import * as helpActionTypes from './../../store/actions/helpAction';

/**
 * Weeks Litter container
 */
class WeeksLitter extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  greyed() {
    const {selectedPregnant, selectedLactation,
      defaultValues, onSelectLitter, selectedAnimalType} = this.props;
    // Default is not greyed
    let greyedWeeks = true;
    let greyedLitter = true;

    // Rules
    if(selectedPregnant){
      greyedWeeks = false;
    }
    if(selectedLactation){
      greyedWeeks = false;
      greyedLitter = false;
    }

    // Default values
    if(!selectedPregnant && !selectedLactation){
      defaultValues(selectedAnimalType);
    }
    if(selectedPregnant && !selectedLactation){
      onSelectLitter(5);
    }

    // Return values for rendering
    return {greyedWeeks: greyedWeeks, greyedLitter: greyedLitter};
  }

  getMaxWeeks(){
    const {selectedPregnant, selectedLactation, selectedAnimalType} = this.props;
    if(selectedPregnant){
      return 9;
    }
    else if(selectedLactation){
      if(selectedAnimalType === animalTypeValues.DOG){
        return 8;
      }
      else{
        return 7;
      }
    }
    return 9;
  }

  render() {
    const {data, error, pending, selectedWeeks, selectedLitter,
      onSelectWeeks, onSelectLitter, readyAnimalType, defaultValues,
      ready, readySignalment, selectedPregnant, setPregnancyId,
      selectedLactation, setLactationId, selectedSterilised,
      setSterilisedId, selectedAnimalType, openModalWithContent} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending && readyAnimalType && readySignalment) {
      defaultValues(selectedAnimalType);
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Get greyed values
    const {greyedWeeks, greyedLitter} = this.greyed();
    // Get max weeks
    const maxWeeks = this.getMaxWeeks();
    // If pregnancy
    if(selectedPregnant){
      setPregnancyId(selectedWeeks, selectedAnimalType);
    }
    else{
      setPregnancyId(null, selectedAnimalType);
    }
    // If lactation
    if(selectedLactation){
      setLactationId(selectedWeeks, selectedAnimalType);
    }
    else{
      setLactationId(null, selectedAnimalType);
    }
    // If sterilised
    if(selectedSterilised){
      setSterilisedId(1);
    }
    else{
      setSterilisedId(0);
    }
    // Return switcher
    return (
      <div className='nppe2-fc-weeks-litter-slider__wrapper'>
        {error && <span className='nppe2-fc-weeks-litter-slider__error'>{error}</span>}
        {!error &&
        <WeeksLitterSlider
          data={data}
          selectedWeeks={selectedWeeks}
          selectedLitter={selectedLitter}
          onSelectWeeks={onSelectWeeks}
          onSelectLitter={onSelectLitter}
          maxWeeks={maxWeeks}
          greyedWeeks={greyedWeeks}
          greyedLitter={greyedLitter}
          openModalWithContent={openModalWithContent}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedPregnant: state.signalmentReducer.selectedPregnant,
    selectedLactation: state.signalmentReducer.selectedLactation,
    selectedSterilised: state.signalmentReducer.selectedSterilised,
    selectedWeeks: state.weeksLitterReducer.selectedWeeks,
    selectedLitter: state.weeksLitterReducer.selectedLitter,
    error: state.weeksLitterReducer.error,
    data: state.weeksLitterReducer.data,
    pending: state.weeksLitterReducer.pending,
    readySignalment: state.signalmentReducer.ready,
    readyAnimalType: state.animalTypeReducer.ready,
    selectedAnimalType: state.animalTypeReducer.animalType,
    ready: state.weeksLitterReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchWeeksLitterAction
      },
      dispatch,
    ),
    onSelectWeeks: (value) => dispatch({
      type: actionTypes.SELECT_WEEKS,
      selectedWeeks: value,
    }),
    onSelectLitter: (value) => dispatch({
      type: actionTypes.SELECT_LITTER,
      selectedLitter: value,
    }),
    defaultValues: (selectedAnimalType) => dispatch({
      type: actionTypes.DEFAULT,
      selectedAnimalType: selectedAnimalType,
    }),
    setPregnancyId: (id, selectedAnimalType) => dispatch({
      type: actionTypes.SET_PREGNANCY,
      pregnancyFactorId: id,
      selectedAnimalType: selectedAnimalType,
    }),
    setLactationId: (id, selectedAnimalType) => dispatch({
      type: actionTypes.SET_LACTATION,
      lactationFactorId: id,
      selectedAnimalType: selectedAnimalType,
    }),
    setSterilisedId: (id) => dispatch({
      type: actionTypes.SET_STERILISED,
      sterilisedFactorId: id,
    }),
    openModalWithContent: (key) => dispatch({
      type: helpActionTypes.OPEN_MODAL_WITH_CONTENT,
      key: key,
      open: true,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(WeeksLitter);
